export const uniqueIds = ids => {
  if (!Array.isArray(ids)) return [];
  return Array.from(new Set(ids.filter(Boolean).map(String)));
};

export const sameIdSet = (a, b) => {
  const left = uniqueIds(a).sort();
  const right = uniqueIds(b).sort();
  if (left.length !== right.length) return false;
  return left.every((id, i) => id === right[i]);
};

/** Mescla seleção manual da página com IDs já escolhidos (até Salvar). */
export function mergeCrossPageSelection(
  globalIds,
  pageRowIds,
  selectedOnPageIds
) {
  const pageIds = new Set(uniqueIds(pageRowIds));
  const global = uniqueIds(globalIds);
  const fromPage = uniqueIds(selectedOnPageIds);
  if (fromPage.length === 0) {
    return global.filter(id => !pageIds.has(id));
  }
  const kept = global.filter(id => !pageIds.has(id));
  return uniqueIds([...kept, ...fromPage]);
}

export const snapshotWizardBaseline = state => ({
  nome: (state.nome || "").trim(),
  descricao: state.descricao || null,
  ativo: state.ativo !== false,
  idformapagtos: uniqueIds(state.idformapagtos)
});

export const labelRestricaoFormas = (idformapagtos, qtdPlanosDisponiveis) => {
  const n = (idformapagtos || []).length;
  if (n === 0) return "Sem restrição";
  if (qtdPlanosDisponiveis > 0 && n >= qtdPlanosDisponiveis) {
    return "Todos os planos";
  }
  return `Restrição (${n} plano${n === 1 ? "" : "s"})`;
};

export const buildCreatePayload = (state, idfornecedor) => ({
  idfornecedor,
  nome: (state.nome || "").trim(),
  descricao: state.descricao || null,
  ativo: state.ativo !== false,
  idformapagtos: uniqueIds(state.idformapagtos)
});

export const buildUpdatePayload = state => ({
  nome: (state.nome || "").trim(),
  descricao: state.descricao || null,
  ativo: state.ativo !== false,
  idformapagtos: uniqueIds(state.idformapagtos)
});

export const defaultWizardState = idfornecedor => ({
  idperfil: null,
  idfornecedor,
  nome: "",
  descricao: "",
  ativo: true,
  idformapagtos: []
});
